import { ChangeDetectionStrategy, Component, computed, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CardBuilder } from '@core/classes/card-builder';
import { SvgIconConfig } from '@core/classes/card-classes';
import { TCardConfig, TCardData } from '@core/types/card';
import { MainBlocksV2ComponentImports } from '@pages/main/blocks-v2/main-blocks-v2.import';
import { cardsData } from '@pages/main/db/main.db';
import { DEFAULT_LANG } from '@translate/constants/available-langs';
import { LanguageService } from '@translate/services/language.service';

@Component({
  selector: 'noda-main-blocks-v2',
  standalone: true,
  templateUrl: './main-blocks-v2.component.html',
  styleUrls: ['./main-blocks-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: MainBlocksV2ComponentImports,
})
export class MainBlocksV2Component {
  private cardBuilder: CardBuilder<string> = new CardBuilder<string>();
  private languageService: LanguageService = inject(LanguageService);

  protected cards: TCardConfig<string>[] = this.buildCards();
  private currentLang: Signal<string> = toSignal(this.languageService.langChanges$, {
    initialValue: this.languageService.activeLang,
  });

  protected isDefaultLang: Signal<boolean> = computed(() => {
    return this.currentLang() === DEFAULT_LANG;
  });

  private buildCards(): TCardConfig<string>[] {
    return cardsData.map((card: TCardData<string>) => {
      let tempBuild: CardBuilder<string> = this.cardBuilder
        .addId(card.id)
        .addIcon(new SvgIconConfig(card.icon))
        .addHeader(card.header)
        .addTextContent(card.body)
        .addMetadata(card.btnConfig?.routerLink || card.metadata)
        .addOptions({ orientation: card.orientation, useHover: true });

      if (card.images) {
        tempBuild = tempBuild.addImage(card.images.picture);
      }

      if (card.btnConfig) {
        tempBuild = tempBuild.addAction(card.btnConfig);
      }

      return tempBuild.build();
    });
  }

  public getLink(block: TCardConfig<string>): string {
    return block.metadata as string;
  }
}
